import React from 'react'
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import Profile from './Profile'
import Explore from '../Explore/Explore'
import './style.scss'

const RightSection = ({profile, explore}) => {
    return (
        <>
            <Tabs defaultActiveKey="profile" id="uncontrolled-tab-example" className="mb-3">
                <Tab eventKey="profile" title="Profile">
                    <Profile data={profile} />
                </Tab>
                <Tab eventKey="explore" title="Explore" unmountOnExit={true}>
                    <>
                    <h5>Profiles Specially for you  <span> (swipe to see) </span> : </h5> <br/>
                    {console.log(explore)}
                    <Explore data={explore} />
                    </>
                </Tab>
               
            </Tabs>
        </>
    )
}

export default RightSection
